// extracted by mini-css-extract-plugin
export default {"highlightText":"CPPf3SiZ2oMiH9LPXNKf","highlight":"etO17Ot0SQt897yFUh4x"};